<nz-tag [nzColor]="tagColor">
  {{ cvcFormControlStatus ? (cvcFormControlStatus | lowercase) : 'UNKNOWN' }}
</nz-tag>
